import {
	Hcphco,
	ProfileVisit,
	RecentSearch,
	SearchAsYouTypeResult
} from '@/core/graphql/generated/types';

export type ValidProfileVisit = {
	__typename: ProfileVisit['__typename'];
	lastVisit: ProfileVisit['lastVisit'];
	profile: Hcphco;
};

export type AdvancedSearch = {
	__typename?: 'AdvancedSearch';
};

export type SeachWithQueryString = RecentSearch & {
	queryString: string;
};

export type QuickSearchOption =
	| SearchAsYouTypeResult
	| ValidProfileVisit
	| SeachWithQueryString
	| AdvancedSearch;

type GuardInput = { __typename?: string } | null | undefined;

export const isHcpHco = (option: GuardInput): option is Hcphco =>
	option?.__typename === 'HCP' || option?.__typename === 'HCO';

export const isAdvancedSearch = (
	option: GuardInput
): option is AdvancedSearch => option?.__typename === 'AdvancedSearch';

export const isProfileVisit = (
	option: GuardInput
): option is ValidProfileVisit => option?.__typename === 'ProfileVisit';

export const isRecentSearch = (
	option: GuardInput
): option is SeachWithQueryString => option?.__typename === 'RecentSearch';

export const isRecentHistory = (
	option: GuardInput
): option is ValidProfileVisit | SeachWithQueryString =>
	isProfileVisit(option) || isRecentSearch(option);

export const isQuickSearchResult = (
	option: GuardInput
): option is SearchAsYouTypeResult =>
	option?.__typename === 'SearchAsYouTypeResult';
